export const TECHNOLOGIES_ERROR_MESSAGE =
  'Error in fetching technologies, please try again.';

export const TECHNOLOGIES_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 502, 503, 504,
];
